module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"loadingPosts":"Lade Beiträge...","noPosts":"Bisher noch keinen Beitrag, besuche diese Seite später nochmal","loadMore":"Mehr laden...","pageTitle":"Beiträge"},"en":{"loadingPosts":"Loading posts...","noPosts":"No post here yet. Please visit us later again.","loadMore":"Load more...","pageTitle":"Posts"}}')
  delete Component.options._Ctor
}
